import { OrgContactInfo, normalizeContactInfo } from './contacts';

export type OrgUnitRecord = {
  id?: number;
  name: string;
  organizationalUnitTypeId: number | null;
  parentId: number | null;
  code?: string | null;
  entityIdentifier?: string | null;
  licenceNumber?: string | null;
  parentEntity?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  orgContactInfo: OrgContactInfo;
  ancestors?: { name: string }[] | null;
  [key: string]: unknown;
};

/** The API record as the editor holds it; every field the screen never shows is kept for the save. */
export function normalizeOrgUnit(raw: any): OrgUnitRecord {
  return {
    ...raw,
    name: raw?.name ?? '',
    organizationalUnitTypeId: raw?.organizationalUnitTypeId ?? null,
    parentId: raw?.parentId ?? null,
    orgContactInfo: normalizeContactInfo(raw?.orgContactInfo),
  };
}

export function newOrgUnitStub(organizationalUnitTypeId: number | null): OrgUnitRecord {
  return { name: '', organizationalUnitTypeId, parentId: null, orgContactInfo: normalizeContactInfo(null) };
}

export function formatAncestorPath(ancestors: { name: string }[] | null | undefined): string {
  return Array.isArray(ancestors) ? ancestors.map(ancestor => ancestor.name).join(' ⇒ ') : '';
}
